"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ramda_1 = require("ramda");
var react_1 = __importStar(require("react"));
var react_dropzone_1 = __importDefault(require("react-dropzone"));
var styled_components_1 = __importStar(require("styled-components"));
var use_query_params_1 = require("use-query-params");
// eslint-disable-next-line max-len
var __1 = require("../../../..");
var Button_1 = __importDefault(require("../../../Button/Button"));
var LinkButton_1 = __importDefault(require("../../../Button/LinkButton"));
var ZahranicniAdresaField_1 = require("../../../Form/fields/AddressField/ZahranicniAdresaField");
var DruhyDokladuField_1 = __importDefault(require("../../../Form/fields/DruhyDokladuField"));
var TextAreaField_1 = __importDefault(require("../../../Form/fields/TextAreaField"));
var Form_1 = __importDefault(require("../../../Form/Form"));
var Popup_1 = __importDefault(require("../../../Popup/Popup"));
var utils_1 = require("../Pomucky/utils");
var PojisteniTable_1 = __importDefault(require("./PojisteniTable"));
var InformativniDiv = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: #e5ebf0;\n  padding: 9px 16px;\n  margin: 1rem 3rem 3rem 3rem;\n  display: flex;\n  justify-content: space-between;\n  ", "\n"], ["\n  background-color: #e5ebf0;\n  padding: 9px 16px;\n  margin: 1rem 3rem 3rem 3rem;\n  display: flex;\n  justify-content: space-between;\n  ",
    "\n"])), function (_a) {
    var isPopup = _a.isPopup;
    return isPopup && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      margin: 1rem 0rem 1rem 0rem;\n      background-color: #eaeff3;\n    "], ["\n      margin: 1rem 0rem 1rem 0rem;\n      background-color: #eaeff3;\n    "])));
});
var StyledInfoDiv = styled_components_1.default(ZahranicniAdresaField_1.InfoDiv)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding: 10px 36px 10px 20px;\n  margin: 1rem 3rem 3rem 3rem;\n  font-size: 15px;\n  line-height: 24px;\n  letter-spacing: 0.0125em;\n  color: #3b3b3b;\n"], ["\n  display: flex;\n  align-items: center;\n  padding: 10px 36px 10px 20px;\n  margin: 1rem 3rem 3rem 3rem;\n  font-size: 15px;\n  line-height: 24px;\n  letter-spacing: 0.0125em;\n  color: #3b3b3b;\n"])));
var PopupChildren = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  overflow: auto;\n  max-height: 90vh;\n  margin: 1em;\n"], ["\n  overflow: auto;\n  max-height: 90vh;\n  margin: 1em;\n"])));
var FileDiv = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  background-color: #f6f5f5;\n  display: flex;\n  justify-content: center;\n  flex-direction: COLUMN;\n  border: dashed 1px #dddddd;\n  margin-bottom: 1em;\n  transition: 0.2s;\n  cursor: pointer;\n  &:hover {\n    background-color: #e5ebf0;\n  }\n"], ["\n  background-color: #f6f5f5;\n  display: flex;\n  justify-content: center;\n  flex-direction: COLUMN;\n  border: dashed 1px #dddddd;\n  margin-bottom: 1em;\n  transition: 0.2s;\n  cursor: pointer;\n  &:hover {\n    background-color: #e5ebf0;\n  }\n"])));
var CenteredDiv = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: FLEX;\n  justify-content: center;\n  margin: 1em;\n"], ["\n  display: FLEX;\n  justify-content: center;\n  margin: 1em;\n"])));
var InfoText = styled_components_1.default.span(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  align-self: center;\n  font-size: 11px;\n  line-height: 22px;\n  margin-bottom: 5px;\n  padding: 0 16px;\n  text-align: center;\n  color: #686868;\n  letter-spacing: 0.0125em;\n"], ["\n  align-self: center;\n  font-size: 11px;\n  line-height: 22px;\n  margin-bottom: 5px;\n  padding: 0 16px;\n  text-align: center;\n  color: #686868;\n  letter-spacing: 0.0125em;\n"])));
var MsgWrap = styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  padding: 0 18px 32px;\n"], ["\n  padding: 0 18px 32px;\n"])));
var NahratStyledLabel = styled_components_1.default.label(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  margin: 0.5rem 0;\n  padding: 0.625rem 1.25rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background-color: transparent;\n  vertical-align: middle;\n  text-align: center;\n  -webkit-appearance: none;\n  border: 1px solid #2362a2;\n  border-radius: 3px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  letter-spacing: 0.05em;\n  line-height: 1.5;\n  text-transform: uppercase;\n  color: #2362a2;\n  cursor: pointer;\n"], ["\n  margin: 0.5rem 0;\n  padding: 0.625rem 1.25rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background-color: transparent;\n  vertical-align: middle;\n  text-align: center;\n  -webkit-appearance: none;\n  border: 1px solid #2362a2;\n  border-radius: 3px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  letter-spacing: 0.05em;\n  line-height: 1.5;\n  text-transform: uppercase;\n  color: #2362a2;\n  cursor: pointer;\n"])));
var nahraniValidation = function (values, oprava) {
    var druhLens = ramda_1.lensPath(['TypPojisteni']);
    return ramda_1.pipe(ramda_1.when(function () { return !oprava && !ramda_1.view(druhLens, values).filter(function (d) { return d.id !== undefined; }).length; }, ramda_1.set(druhLens, 'Druh dokumentu je povinný.')))({});
};
var DetailPojisteni = function (_a) {
    var _b;
    var idZnalce = _a.idZnalce, datumZapisu = _a.datumZapisu, upusteniOdDolozeni = _a.upusteniOdDolozeni, zobrazStarePojisteni = _a.zobrazStarePojisteni;
    var pojisteniUrl = __1.useConfig().pojisteniUrl;
    var pojisteniJSON = __1.usePostJSON(pojisteniUrl + "/PojisteniOsoby");
    var _c = react_1.useState(false), isOpen = _c[0], setIsOpen = _c[1];
    var _d = react_1.useState(null), file = _d[0], setFile = _d[1];
    var _e = react_1.useState(undefined), Oprava = _e[0], setOprava = _e[1];
    var _f = react_1.useState(), pojisteni = _f[0], setPojisteni = _f[1];
    var _g = react_1.useState(1), page = _g[0], setPage = _g[1];
    var token = __1.useToken();
    var roleIds = (token.getDataFromToken() || []).roleIds;
    var idDoklad = use_query_params_1.useQueryParam('idDoklad', use_query_params_1.JsonParam)[0] || undefined;
    var postDokad = __1.usePostFile(pojisteniUrl + "/Doklad");
    var postOpravnyDokument = __1.usePostFile(pojisteniUrl + "/OpravnyDokument");
    var query = {
        idZnalce: idZnalce,
        idDoklad: idDoklad,
        strankovani: {
            pocetNaStranku: 5,
        },
        datumZapisu: datumZapisu,
        upusteniOdDolozeni: upusteniOdDolozeni,
    };
    var _h = react_1.useState(), errorMsg = _h[0], setErrorMsg = _h[1];
    var maxSize = 20971520;
    var accept = 'image/png, image/jpeg, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    var isNahratDisabled = (((_b = pojisteni === null || pojisteni === void 0 ? void 0 : pojisteni.doklady) === null || _b === void 0 ? void 0 : _b.zaznamy) || []).find(function (p) { return p.dokumenty.find(function (d) { return d.stav.id === __1.StavPojisteni.CekaNaSchvaleni; }); });
    var loadPojisteni = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, pojisteniJSON(query)];
                case 1:
                    response = _a.sent();
                    if (__1.isRight(response)) {
                        setPojisteni(response.value);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    react_1.useEffect(function () {
        loadPojisteni();
    }, [idDoklad, upusteniOdDolozeni]);
    var handleLoadMore = function () { return __awaiter(void 0, void 0, void 0, function () {
        var strankaLens, zaznamyLens, nextPage, response, noveZaznamy_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    strankaLens = ramda_1.lensPath(['strankovani', 'stranka']);
                    zaznamyLens = ramda_1.lensPath(['doklady', 'zaznamy']);
                    nextPage = page + 1;
                    return [4 /*yield*/, pojisteniJSON(ramda_1.set(strankaLens, nextPage, query))];
                case 1:
                    response = _a.sent();
                    if (__1.isRight(response)) {
                        noveZaznamy_1 = ramda_1.view(zaznamyLens, response.value) || [];
                        setPojisteni(ramda_1.over(zaznamyLens, function (z) { return ramda_1.concat(z, noveZaznamy_1); }, pojisteni));
                        setPage(nextPage);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleChange = function (newFiles, rejectionFiles) {
        if (newFiles.length > 0 && !rejectionFiles.length)
            setFile(newFiles);
        if (rejectionFiles.length > 0) {
            if (rejectionFiles[0].file.size > maxSize) {
                setErrorMsg("Soubor \"" + rejectionFiles[0].file.name + "\" je p\u0159\u00EDli\u0161 velk\u00FD.");
            }
            if (!accept.includes(rejectionFiles[0].file.type) || rejectionFiles[0].file.type === '') {
                setErrorMsg("Typ souboru " + rejectionFiles[0].file.type + " nen\u00ED podporov\u00E1n.");
            }
        }
        else {
            setErrorMsg(undefined);
        }
    };
    var handleOdstranit = function () {
        setFile(null);
    };
    var handleOpravu = function (oprava) {
        setOprava(oprava);
        setIsOpen(!isOpen);
    };
    var handleClose = function () {
        setIsOpen(false);
        setOprava(undefined);
        setFile(null);
    };
    var handleSave = function (val, form) { return __awaiter(void 0, void 0, void 0, function () {
        var formData, dokumentJson, response, opravaJson;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    formData = new FormData();
                    formData.append('File', file[0]);
                    dokumentJson = {
                        IdsDruhuDokladu: (_a = val.TypPojisteni) === null || _a === void 0 ? void 0 : _a.filter(function (d) { return d.id; }).map(function (d) { return d.id; }),
                        IdPojisteni: pojisteni === null || pojisteni === void 0 ? void 0 : pojisteni.id,
                        NazevPojistitele: val.nazevPojistitele,
                        DobaTrvaniPojisteni: val.dobaTrvaniPojisteni,
                        LimitPojistnehoPlneni: val.limitPojistnehoPlneni,
                        Poznamka: val.PoznamkaPojisteni,
                        IdZnalec: idZnalce,
                    };
                    if (!Oprava) return [3 /*break*/, 2];
                    opravaJson = __assign(__assign({}, dokumentJson), { ZamitnutyDokumentId: Oprava.idZamitnuty, IdDoklad: Oprava.idDoklad });
                    formData.append('dokumentJson', JSON.stringify(opravaJson));
                    return [4 /*yield*/, postOpravnyDokument(formData)];
                case 1:
                    response = _b.sent();
                    return [3 /*break*/, 4];
                case 2:
                    formData.append('dokumentJson', JSON.stringify(dokumentJson));
                    return [4 /*yield*/, postDokad(formData)];
                case 3:
                    response = _b.sent();
                    _b.label = 4;
                case 4:
                    if (__1.isRight(response)) {
                        setPage(1);
                        loadPojisteni();
                        handleClose();
                    }
                    else {
                        form.setStatus({ type: 'error', message: response.value.message });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(utils_1.StyledH2, { isDetail: true }, "Profesn\u00ED poji\u0161t\u011Bn\u00ED"),
        (pojisteni === null || pojisteni === void 0 ? void 0 : pojisteni.upusteniOdDolozeni) ? (react_1.default.createElement(StyledInfoDiv, null,
            react_1.default.createElement(__1.BulbIcon, null),
            "Subjekt nem\u00E1 povinnost b\u00FDt poji\u0161t\u011Bn.")) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(PojisteniTable_1.default, { doklady: pojisteni === null || pojisteni === void 0 ? void 0 : pojisteni.doklady, idZnalce: idZnalce, page: page, handleOpravu: handleOpravu, handleLoadMore: handleLoadMore, idDoklad: idDoklad, isNahratDisabled: isNahratDisabled }),
            zobrazStarePojisteni && (react_1.default.createElement(InformativniDiv, null,
                react_1.default.createElement("div", null,
                    "Term\u00EDn pro dolo\u017Een\u00ED dokladu o poji\u0161t\u011Bn\u00ED: ",
                    react_1.default.createElement("b", null, __1.formatDate(pojisteni === null || pojisteni === void 0 ? void 0 : pojisteni.aktualniDatumDolozeni))),
                __1.isInRole([__1.Role.znalec], roleIds) && (react_1.default.createElement(__1.Tooltip, { content: "V\u00E1mi nahran\u00FD doklad o poji\u0161t\u011Bn\u00ED je v tuto chv\u00EDli posuzov\u00E1n \u2013 aktu\u00E1ln\u011B tedy nen\u00ED mo\u017En\u00E9 nahr\u00E1t dal\u0161\u00ED.", disabled: !isNahratDisabled },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(LinkButton_1.default, { onClick: function () { return setIsOpen(true); }, type: "button", disabled: isNahratDisabled }, "Nahr\u00E1t poji\u0161t\u011Bn\u00ED")))))))),
        react_1.default.createElement(Popup_1.default, { open: isOpen, onClose: handleClose },
            react_1.default.createElement(Form_1.default, { initialValues: {}, validate: function (val) { return nahraniValidation(val, Oprava); }, onSubmit: function (val, form) { return handleSave(val, form); } }, function (_a) {
                var isSubmitting = _a.isSubmitting;
                return (react_1.default.createElement(PopupChildren, null,
                    errorMsg && (react_1.default.createElement(MsgWrap, null,
                        react_1.default.createElement(__1.Message, { type: "error", onClose: function () { return setErrorMsg(undefined); } }, errorMsg))),
                    Oprava ? react_1.default.createElement("h3", null, "Nahr\u00E1t opravnou verzi profesn\u00EDho poji\u0161t\u011Bn\u00ED") : react_1.default.createElement("h3", null, "Nahr\u00E1t profesn\u00ED poji\u0161t\u011Bn\u00ED"),
                    !file || errorMsg ? (react_1.default.createElement(react_dropzone_1.default, { onDrop: function (acceptedFiles, fileRejections) { return handleChange(acceptedFiles, fileRejections); }, maxSize: maxSize, accept: accept }, function (_a) {
                        var getRootProps = _a.getRootProps, getInputProps = _a.getInputProps;
                        return (react_1.default.createElement("section", null,
                            react_1.default.createElement("div", __assign({}, getRootProps()),
                                react_1.default.createElement("input", __assign({}, getInputProps())),
                                react_1.default.createElement(FileDiv, null,
                                    react_1.default.createElement("br", null),
                                    react_1.default.createElement(CenteredDiv, { style: { margin: '1rem 1rem 0', fontSize: 15 } }, "P\u0159et\u00E1hn\u011Bte soubor nebo"),
                                    react_1.default.createElement(CenteredDiv, { style: { margin: 0 } },
                                        react_1.default.createElement(NahratStyledLabel, null, "Nahrajte ze za\u0159\u00EDzen\u00ED")),
                                    react_1.default.createElement(InfoText, null, "Upozorn\u011Bn\u00ED: M\u016F\u017Eete vlo\u017Eit maxim\u00E1ln\u011B jeden soubor o velikosti do 20MB, a to ve form\u00E1tu PDF/A, DOC/DOCX, JPG nebo PNG."),
                                    react_1.default.createElement(InfoText, null, "Jeden soubor m\u016F\u017Ee obsahovat v\u00EDce druh\u016F vkl\u00E1dan\u00FDch dokument\u016F (dokl\u00E1dan\u00FDch z v\u00EDce d\u016Fvod\u016F).")))));
                    })) : (react_1.default.createElement(InformativniDiv, { isPopup: true },
                        file[0].name,
                        react_1.default.createElement(LinkButton_1.default, { onClick: handleOdstranit }, "Odstranit"))),
                    !Oprava && react_1.default.createElement(DruhyDokladuField_1.default, { name: "TypPojisteni", label: "Druh vkl\u00E1dan\u00E9ho dokumentu", maxMenuHeight: 110 }),
                    !Oprava && react_1.default.createElement(__1.TextField, { label: "N\u00E1zev pojistitele", name: "nazevPojistitele", size: "md" }),
                    !Oprava && react_1.default.createElement(__1.DateField, { label: "Doba trv\u00E1n\u00ED poji\u0161t\u011Bn\u00ED", name: "dobaTrvaniPojisteni", size: "md" }),
                    !Oprava && react_1.default.createElement(__1.NumberField, { label: "Limit pojistn\u00E9ho pln\u011Bn\u00ED", name: "limitPojistnehoPlneni", size: "md", toolTip: "Vypl\u0148te limit pojistn\u00E9ho pln\u011Bn\u00ED" }),
                    react_1.default.createElement(TextAreaField_1.default, { name: "PoznamkaPojisteni", label: "Pozn\u00E1mka", toolTip: "Dopl\u0148te pozn\u00E1mku k dokumentu profesn\u00EDho poji\u0161t\u011Bn\u00ED", maxLength: 200 }),
                    file && !errorMsg && (react_1.default.createElement(CenteredDiv, null,
                        react_1.default.createElement(Button_1.default, { type: "submit", name: "NahratDoklad", primary: true, loading: isSubmitting }, "NAHR\u00C1T DOKLAD")))));
            }))));
};
DetailPojisteni.defaultProps = {
    upusteniOdDolozeni: false,
    zobrazStarePojisteni: true,
};
exports.default = DetailPojisteni;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
